import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { publishReplay, refCount, retry, take } from 'rxjs/operators';
import { ShimanoLanguageService } from '../language/shimano-language.service';

export interface ProductDescriptionClassificationPayload {
  productOptions: string;
  productCode: string;
}

@Injectable({
  providedIn: 'root',
})
export class ProductDescriptionClassificationService {
  headers = new HttpHeaders().set('Content-Type', 'application/json');

  private cachedProductOptions$: any = {};

  cleanReferences() {
    throw new Error('Method not implemented.');
  }

  constructor(
    protected http: HttpClient,
    protected languageService: ShimanoLanguageService,
    private occEndpointsService: OccEndpointsService
  ) {}

  get activeLanguage(): string {
    let activeLanguage: string;
    this.languageService.getActive().subscribe((lang) => (activeLanguage = lang));
    return activeLanguage;
  }

  getProductOptions(payload: ProductDescriptionClassificationPayload, lang = this.activeLanguage): Observable<any> {
    const params = new HttpParams().set('productOptions', payload.productOptions as any);
    const idString = [payload.productCode, payload.productOptions, lang].join();

    if (!this.cachedProductOptions$[idString]) {
      this.cachedProductOptions$[idString] = this.http
        .get(this.occEndpointsService.buildUrl(`/products/${payload.productCode}/options?fields=FULL`), {
          params,
          headers: this.headers,
        })
        .pipe(retry(1), publishReplay(), refCount(), take(1));
    }
    return this.cachedProductOptions$[idString];
  }
}
